import { gql } from '@apollo/client';
import { DateTime } from 'luxon';
import { useState, useEffect } from 'react';
import { useShiftDataUpdaterFragment } from './__generated__/useShiftDataUpdater.generated';

export function useShiftDataUpdater(
  data: useShiftDataUpdaterFragment | undefined | null
) {
  const [shiftData, setShiftData] = useState<ReturnType<typeof parseShift>>();
  useEffect(() => {
    if (data) {
      setShiftData(parseShift(data));
    }
    const interval = data
      ? setInterval(() => {
          if (data) {
            // TODO This is problematic if the shift ends on a different machine.
            setShiftData(parseShift(data));
          }
        }, 1000 * 30)
      : undefined;
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [data]);
  return shiftData;
}

function parseShift(shift: NonNullable<useShiftDataUpdaterFragment>) {
  const startTime = DateTime.fromJSDate(new Date(shift.startTime));
  const diff = DateTime.now().diff(startTime, ['hours', 'minutes', 'seconds']);
  return {
    hours: diff.hours,
    minutes: diff.minutes,
    startTime: startTime.toLocaleString(DateTime.TIME_SIMPLE),
  };
}

const fragment = gql`
  fragment useShiftDataUpdater on Shift {
    startTime
  }
`;
